import { PlatformHighlight } from "kreate-common/modules/business-types";
import { z } from "zod";

export const Result = PlatformHighlight;
export type Result = z.infer<typeof Result>;

export type PlatformHighlight$Result = Result;
export const PlatformHighlight$Result = Result;
